import { render, staticRenderFns } from "./RtcGroupVideo.vue?vue&type=template&id=1e616238&scoped=true"
import script from "./RtcGroupVideo.vue?vue&type=script&lang=js"
export * from "./RtcGroupVideo.vue?vue&type=script&lang=js"
import style0 from "./RtcGroupVideo.vue?vue&type=style&index=0&id=1e616238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e616238",
  null
  
)

export default component.exports